import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';

const Footer: React.FC = () => {
  return (
    <DefaultFooter
      style={{
        background: 'none',
        color: '#fff',
      }}
      copyright="Powered by SensorEra"
    />
  );
};

export default Footer;
